import Repository from "./Repository";

export default {
    login(data) {
        return Repository.post("/customer/auth/login", data);
    },
    logout() {
        return Repository.post("/customer/auth/logout");
    },
    signUp(data) {
        return Repository.post("/customer/create", data);
    },
    restorePassword(email) {
        return Repository.post("/customer/password/restore", email);
    },
    getBuzzInfo() {
        return Repository.get("/customer");
    },
    getMytargetInfo() {
        return Repository.get("/customer/mytarget/info");
    },
    authMytarget() {
        return Repository.get("/customer/mytarget/add");
    },
    validateToken(token, change_password_key) {
        let url = "/customer/token_validate?";
        if (change_password_key) {
            url += `change_password_key=${change_password_key}&`;
        }
        url += `token=${token}`;
        return Repository.get(url);
    },
    loginToken(token) {
        return Repository.get(`/customer/auth/login/token?access_token=${token}`);
    },
    changePassword(passwords) {
        return Repository.post("/customer/password/change", passwords);
    },
};
